export const COLOR_AZURE = '#eff4f4';
export const COLOR_BANTAMWEIGHT = '#b3c9cb';
export const COLOR_COBALT = '#007aff';
export const COLOR_DEEPTEAL = '#004a52';
export const COLOR_ERROR = '#d9534f';
export const COLOR_FLYWEIGHT = '#e0e9ea';
export const COLOR_MAGENTA = '#F621FB';
export const COLOR_MIDDLEWEIGHT = '#336e74';
export const COLOR_MINT = '#0aefb8';
export const COLOR_NUMERATOR_GREEN = '#00e36b';
export const COLOR_ORANGE = '#FE971F';
export const COLOR_PINK = '#ea526f';
export const COLOR_PURPLE = '#8053FF';
export const COLOR_RED = '#FF415D';
export const COLOR_SAPPHIRE = '#00a8b8';
export const COLOR_SAPPHIRE_75 = '#1FECFF';
export const COLOR_SAPPHIRE_200 = '#007985';
export const COLOR_SAPPHIRE_300 = '#004b52';
export const COLOR_SAPPHIRE_DARK = '#008c99';
export const COLOR_SUMO = '#002c31';
export const COLOR_WELTERWEIGHT = '#669297';
export const COLOR_WHITE = '#ffffff';
export const COLOR_YELLOW = '#ffd61f';
export const COLOR_YELLOW_50 = '#FEF6D1';

export const COLOR_SCALE_NEGATIVE_80 = '#903143';
export const COLOR_SCALE_NEGATIVE_70 = '#AE3B50';
export const COLOR_SCALE_NEGATIVE_60 = '#CC455F';
export const COLOR_SCALE_NEGATIVE_50 = '#EA526F';
export const COLOR_SCALE_NEGATIVE_40 = '#FF8E9B';
export const COLOR_SCALE_NEGATIVE_30 = '#FFA9B2';
export const COLOR_SCALE_NEGATIVE_20 = '#FFC4C9';
export const COLOR_SCALE_NEGATIVE_10 = '#FFDEE0';
export const COLOR_SCALE_0 = '#E0E9EA';
export const COLOR_SCALE_10 = '#DAFBE2';
export const COLOR_SCALE_20 = '#BCF7CC';
export const COLOR_SCALE_30 = '#9AF2B6';
export const COLOR_SCALE_40 = '#72EC9F';
export const COLOR_SCALE_50 = '#00E36B';
export const COLOR_SCALE_60 = '#00CB67';
export const COLOR_SCALE_70 = '#00A755';
export const COLOR_SCALE_80 = '#006D37';

export const DEFAULT_CHART_COLORS = [
  COLOR_COBALT,
  COLOR_MINT,
  COLOR_YELLOW,
  COLOR_PINK,
  COLOR_SAPPHIRE,
  COLOR_DEEPTEAL,
  COLOR_NUMERATOR_GREEN,
  COLOR_ORANGE,
  COLOR_PURPLE,
  COLOR_MAGENTA,
];

export const FAST_TRACK_CHART_COLORS = [
  COLOR_NUMERATOR_GREEN,
  COLOR_DEEPTEAL,
  COLOR_SAPPHIRE,
  COLOR_YELLOW,
  COLOR_COBALT,
  COLOR_MINT,
  COLOR_RED,
  COLOR_ORANGE,
  COLOR_PURPLE,
  COLOR_MAGENTA,
];

const DEFAULT_GRID_COLORS = [
  COLOR_SCALE_60,
  COLOR_SCALE_50,
  COLOR_SCALE_40,
  COLOR_SCALE_30,
  COLOR_SCALE_20,
  COLOR_SCALE_10,
  COLOR_SCALE_0,
  COLOR_SCALE_NEGATIVE_10,
  COLOR_SCALE_NEGATIVE_20,
  COLOR_SCALE_NEGATIVE_30,
  COLOR_SCALE_NEGATIVE_40,
  COLOR_SCALE_NEGATIVE_50,
  COLOR_SCALE_NEGATIVE_60,
];

export const COLOR_NEGATIVE_SCALE = [
  COLOR_SCALE_NEGATIVE_10,
  COLOR_SCALE_NEGATIVE_20,
  COLOR_SCALE_NEGATIVE_30,
  COLOR_SCALE_NEGATIVE_40,
  COLOR_SCALE_NEGATIVE_50,
  COLOR_SCALE_NEGATIVE_60,
  COLOR_SCALE_NEGATIVE_70,
  COLOR_SCALE_NEGATIVE_80,
];
export const COLOR_POSITIVE_SCALE = [
  COLOR_SCALE_10,
  COLOR_SCALE_20,
  COLOR_SCALE_30,
  COLOR_SCALE_40,
  COLOR_SCALE_50,
  COLOR_SCALE_60,
  COLOR_SCALE_70,
  COLOR_SCALE_80,
];

export const getGridColorsForCount = (count) => {
  if (!count || count < 0 || count >= 13) return DEFAULT_GRID_COLORS;
  if (count === 12)
    return [
      ...DEFAULT_GRID_COLORS.slice(0, Math.floor(count / 2)),
      ...DEFAULT_GRID_COLORS.slice(-Math.floor(count / 2)),
    ];

  const useDefault = count > 5;
  const source = useDefault
    ? DEFAULT_GRID_COLORS
    : [
        COLOR_SCALE_50,
        COLOR_SCALE_30,
        COLOR_SCALE_0,
        COLOR_SCALE_NEGATIVE_30,
        COLOR_SCALE_NEGATIVE_50,
      ];

  const half = Math.floor(count / 2);
  const startSlice = useDefault ? source.slice(1, 1 + half) : source.slice(0, half);
  const endSlice = useDefault
    ? source.slice(source.length - half - 1, source.length - 1)
    : source.slice(-half);

  return [...startSlice, ...(count % 2 === 0 ? [] : [COLOR_SCALE_0]), ...endSlice];
};

export const getRankedColorsForCount = (count) => {
  if (!count || count < 0 || count > COLOR_NEGATIVE_SCALE.length + COLOR_POSITIVE_SCALE.length)
    return [...COLOR_NEGATIVE_SCALE.reverse(), ...COLOR_POSITIVE_SCALE];

  // colors arranged from lowest to highest, with 1 more negative than positive when the count is odd
  const negativeColors = COLOR_NEGATIVE_SCALE.slice(0, Math.ceil(count / 2));
  const positiveColors = COLOR_POSITIVE_SCALE.slice(0, Math.floor(count / 2));
  return [...negativeColors.reverse(), ...positiveColors];
};

export const WORD_CLOUD_COLORS = {
  dark: [COLOR_AZURE, COLOR_FLYWEIGHT, COLOR_BANTAMWEIGHT, COLOR_WELTERWEIGHT],
  light: [COLOR_SUMO, COLOR_DEEPTEAL, COLOR_MIDDLEWEIGHT, COLOR_WELTERWEIGHT],
};
